<template>
	<div
		class="g-block-body-line-border g-block-body-padding"
		:class="{
			'g-block-body-line-border--edit': editable,
			'is-active': editable && active,
			'g-block-body-line-border--h5': h5,
			'g-block-body-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div class="g-block-body-line-border__inner">
			<span
				class="g-block-body-line-border__line"
				:style="{ background: lineColor }"
				aria-hidden="true"
			></span>
			<RichTextEditable
				v-if="editable"
				class="g-block-body-line-border__text"
				:model-value="data.content"
				placeholder="请输入正文"
				@update:model-value="onContentUpdate"
				@focus="onWrapClick"
			/>
			<div
				v-else
				class="g-block-body-line-border__text"
				v-html="data.content || ''"
			></div>
			<span
				class="g-block-body-line-border__line"
				:style="{ background: lineColor }"
				aria-hidden="true"
			></span>
		</div>
	</div>
</template>

<script>
	import RichTextEditable from '../../../components/RichTextEditable.vue';
	import { getTitleThemeColor } from '../../../templates.js';
	import { bodyMixin } from '../shared/bodyMixin.js';

	export default {
		name: 'GBlockBodyLineBorder',
		components: { RichTextEditable },
		mixins: [bodyMixin],
		computed: {
			lineColor() {
				return getTitleThemeColor(this.data);
			},
		},
	};
</script>

<style scoped lang="less">
	@import '../shared/bodyEditShell.less';

	.g-block-body-line-border {
		.body-block-edit-shell();
	}

	.g-block-body-line-border__inner {
		display: flex;
		flex-direction: column;
		gap: 12px;
	}

	.g-block-body-line-border__line {
		display: block;
		width: 100%;
		height: 2px;
		flex-shrink: 0;
	}

	.g-block-body-line-border__text {
		.body-text-base();
	}

	.g-block-body-line-border--h5 {
		.g-block-body-line-border__inner { gap: 0.24rem; }
		.g-block-body-line-border__line { height: 0.04rem; }
		.body-text-base--h5(~'.g-block-body-line-border__text');
	}
</style>
